module.exports = __webpack_public_path__ + "static/media/04-galeria-04-cantina-palacio@2x.2d38daad.jpg";